import script from "./MatchedList.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchedList.vue?vue&type=script&setup=true&lang=js"

import "./MatchedList.vue?vue&type=style&index=0&id=cb02d08e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb02d08e"]])

export default __exports__